import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-cancel-with-reason',
  templateUrl: './common-cancel-with-reason.component.html',
  styleUrls: ['./common-cancel-with-reason.component.scss']
})
export class CommonCancelWithReasonComponent implements OnInit {
//component created by fahim 31-12-2025 

  @Input() Title:any;
  @Input() ReasonModule:any;
  @Input() selectedId:any;
  @Input() cancelType:any;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Output() onRefreshList = new EventEmitter<any>();

  Reason: any = {
    lable: 'Cancellation Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  ReasonValue:any;
  userId:any;

  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
  }

  getChangedValue(value, data){
    if(value){
      this.ReasonValue = value.value;
    } else {
      this.ReasonValue = null;
    }
  }

  GetReasonList(value, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = this.ReasonModule;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  onSaveClick(){
    if(this.ReasonModule === 'Order'){
      this.CancelOrder();
    }else{
      this.CancelBooking()
    }
  }

  CancelOrder() {
    if (!this.ReasonValue) {
      this.toastr.warning('Please select a reason','Warning');
      return;
    }

    this._appService
      .GetByThreeId(
        "OrdersByVehicle",
        "CancelVehicleOrders",
        this.selectedId,
        this.ReasonValue,
        this.userId
      )
      .subscribe(
        (response) => {
          this.SaveDeletedTransactionHistory(this.selectedId);
          this.toastr.success("Order Cancelled Successfully ", "Success");
          if(this.cancelType === 'FTL'){
            this.router.navigateByUrl('/FtlList');
          } else if(this.cancelType === 'LTL'){
            this.router.navigateByUrl('/FtlList?Type=LTL');
          } else if(this.cancelType === 'ContainerMovement'){
            this.router.navigateByUrl('/Container-Movement');
          }
          this.onRefreshList.emit('true')
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  CancelBooking() {
    if (!this.ReasonValue) {
      this.toastr.warning('Please select a reason','Warning');
      return;
    }
    this._appService
      .GetByTwoId(
        "Booking",
        "CancelVehicleBooking",
        this.selectedId,
        this.ReasonValue,
      )
      .subscribe(
        (response) => {
          this.SaveDeletedTransactionHistory(this.selectedId);
          this.toastr.success("Booking Cancelled Successfully ", "Success");
          if(this.cancelType === 'FTL'){
            this.router.navigateByUrl('/FtlList');
          } else if(this.cancelType === 'LTL'){
            this.router.navigateByUrl('/FtlList?Type=LTL');
          } else if(this.cancelType === 'ContainerMovement'){
            this.router.navigateByUrl('/Container-Movement');
          }
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  SaveDeletedTransactionHistory(Id) {
    var obj: any = {};
    obj.TransactionId = Id;
    obj.TransactionType = this.ReasonModule;
    obj.UserId = this.userId;

    this._appService.Post("Common", "SaveDelTransactionHistory", obj).subscribe(
      (response) => { 
        this.Cancel();
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
}
